import { useQuery } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import {
  StreamCardFragmentFragment,
  StreamPricingType,
  StreamSortBy,
} from '@/__generated__/graphql';
import { gql } from '@/__generated__/index.ts';

const NewStreamsQuery = gql(`
  query NewStreamsQuery(
    $limit: Int!
    $nextToken: String
    $pricingType: StreamPricingType
    $sortBy: StreamSortBy
    $minFollowers: Int
  ) {
    streamsAll(
      limit: $limit
      nextToken: $nextToken
      sortBy: $sortBy
      pricingType: $pricingType
      minFollowers: $minFollowers
    ) {
      items {
        ...StreamCardFragment
      }
      nextToken
    }
  }
`);

export const useNewStreams = ({
  limit = 4,
  pricingType = StreamPricingType.Paid,
  nextToken,
}: {
  limit?: number;
  pricingType?: StreamPricingType;
  nextToken?: string;
}) => {
  const toast = useToast();
  const { data, refetch, loading, error } = useQuery(NewStreamsQuery, {
    variables: {
      limit,
      sortBy: StreamSortBy.CreatedAt,
      pricingType: pricingType,
      nextToken: nextToken || null,
      minFollowers: 3,
    },
    fetchPolicy: 'cache-and-network',
    onError: () => {
      toast.error({
        title: 'Failed to fetch streams',
      });
    },
  });

  return {
    streams: data?.streamsAll?.items as StreamCardFragmentFragment[] | null,
    areNewStreamsEmpty: data?.streamsAll?.items?.length === 0,
    nextToken: data?.streamsAll?.nextToken,
    loading,
    refetch,
    error,
  };
};
